export const metersToKm = (meters) => meters / 1000;
